import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { appRoutes, publicRoutes } from './routes.js';
import { AppShell } from './shell/AppShell.js';
import { MeProvider } from './shell/me-context.js';
import { PublicShell } from './shell/PublicShell.js';
import { ToastProvider } from './ui/Toast.js';

function AuthenticatedApp() {
  return (
    <MeProvider>
      <AppShell />
    </MeProvider>
  );
}

/**
 * Composition root: the toast viewport above everything, the public routes outside MeProvider
 * (a 401 there must never trigger the reload), and every other route inside the shell — or, with
 * no session, the sign-in page MeProvider renders in place at that same URL.
 */
export function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route element={<PublicShell />}>{publicRoutes()}</Route>
          <Route path="/" element={<AuthenticatedApp />}>{appRoutes()}</Route>
        </Routes>
      </ToastProvider>
    </BrowserRouter>
  );
}
